import i18n from 'i18next'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classes from './LoginWrapper.module.scss'

import { ReactComponent as Logo } from 'assets/MB-Rent-logo-einzeilig_neg.svg'
import { ExternalLink } from 'components'
import { ImpressumModal } from 'components/Footer/ImpressumModal'
import { PrivacyStatementModal } from 'components/Footer/PrivacyStatementModal'
import { CookieDisclaimer } from '../../components/CookieDisclaimer/CookieDisclaimer'
import { LanguageDropdown } from '../../components/LanguageChange/LanguageDropdown'

interface LoginWrapperProps {
  title: string
  children: React.ReactNode
}

export const LoginWrapper: React.FunctionComponent<LoginWrapperProps> = ({
  title,
  children,
}) => {
  const [cookiesAccepted, setCookiesAccepted] = useState<string>(
    sessionStorage.getItem('acceptCookies') || ''
  )

  const { t } = useTranslation()

  return (
    <div className={classes.login}>
      <div className={classes.wrapper}>
        <main className={classes.container}>
          <header className={classes.header}>
            <div className={classes.langaugeChanger}>
              <LanguageDropdown language={i18n.language} />
            </div>
            <div className={classes.headerMain}>
              <Logo className={classes.logo} title="MBVM Logo" />
            </div>
          </header>
          <h2 id="login-title-e2e" className={classes.title}>
            {title}
          </h2>
          <section className={classes.content}>{children}</section>
        </main>
      </div>

      <footer className={classes.footer}>
        <ImpressumModal />

        <PrivacyStatementModal />

        <ExternalLink
          href={t('components.footer.bpo.url')}
          variant="small"
          theme="dark"
          className={classes.link}
          target="_blank"
        >
          {t('components.footer.bpo.heading')}
        </ExternalLink>
      </footer>

      <div className={classes.background}></div>
      {cookiesAccepted ? '' : <CookieDisclaimer accept={setCookiesAccepted} />}
    </div>
  )
}
